module.exports = __webpack_public_path__ + "static/media/rabbit.95dfdc45.png";